import { h } from "preact";

import IconProps from "./IconProps";

interface Props {
    type?: "default" | "small";
}

const DEFAULT_COLOR = "var(--label-secondary)";

function IconApproval({
    class: cssClass,
    color,
    type = "default"
}: IconProps & Props) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    if (type === "small") {
        return (
            <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M8 13H4a1 1 0 0 1-1-1V8a5 5 0 1 1 5 5zM2 8a6 6 0 1 1 6 6H4a2 2 0 0 1-2-2V8zm8.623-1.418a.5.5 0 0 0-.746-.664l-2.742 3.08-1.012-1.136a.5.5 0 1 0-.746.665l1.384 1.555a.5.5 0 0 0 .747 0l3.115-3.5z"/>
            </svg>

        );
    }

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M12 19H6a1 1 0 0 1-1-1v-6a7 7 0 1 1 7 7zm-8-7a8 8 0 1 1 8 8H6a2 2 0 0 1-2-2v-6zm11.385-2.18a.5.5 0 1 0-.77-.64l-3.769 4.538-1.461-1.76a.5.5 0 1 0-.77.64l1.847 2.221a.5.5 0 0 0 .769 0l4.154-5z"/>
        </svg>
    );
}

export default IconApproval;

